<template>
  <div style="padding:10px">
    <div style="font-weight: bold;text-align: center;">
        <div style="font-size: 20px;">TOTAL</div>
    <div style="font-size: 30px;">{{ money( total ) }}</div>
</div>
    <el-form
      ref="ticketForm"
      :model="formData"
      :rules="rules"
      label-position="left"
      label-width="120px"
      style="padding:10px"
    >
      <div v-for="(ticket, i) in tickets" :key="i">
        <el-form-item
          :label="ticket.seat_number + ' SEAT'"
          :prop="'tickets.' + i + '.full_name'"
        >
          <el-input
            v-model="formData.tickets[i].full_name"
            placeholder="Enter Passenger Name"
          />
        <div>{{ money(ticket.total_fare) }}</div>

        </el-form-item>
      </div>
    <div style="text-align: center;">
        <hr>
        <el-button type="primary" @click="submitForm" size="large">SAVE AND PRINT</el-button>
    </div>
    </el-form>
  </div>
</template>

<script>
import { watch } from 'vue';

export default {
  props: ["form", 'booking'],
  data() {
    return {
      tickets: [],
      formData: {
        tickets: [],
      },
      rules: {},
    };
  },
  watch: {
    form: function(){
        this.init()
    }
  },
  computed: {
    total() {
        let sum = 0;
        this.form.tickets.forEach( ticket=> {
            sum += ticket.total_fare
        })

        return sum
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.form?.tickets) return;

      this.tickets = JSON.parse(JSON.stringify(this.form.tickets));

      // If route is ZAM-ISA or ISA-ZAM → auto-fill passengers
        if (this.booking?.route?.code === 'ZAM-ISA' || this.booking?.route?.code === 'ISA-ZAM') {
            // Update all ticket names
            this.tickets = this.tickets.map(ticket => ({
            ...ticket,
            full_name: 'ON-BOARD PASSENGER'
            }));
        }

    this.formData.tickets = JSON.parse(JSON.stringify(this.tickets));

      // Build per-field validator rules (uses closure to capture seat_number)
      this.rules = {};
      this.tickets.forEach((ticket, index) => {
        const prop = `tickets.${index}.full_name`;
        const seat = ticket.seat_number;
        this.rules[prop] = [
          {
            validator: (rule, value, callback) => {
              // trim to treat whitespace as empty
              if (!value || String(value).trim() === "") {
                callback(new Error(`Passenger ${seat} is required`));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ];
      });
    },

    submitForm() {
      // Validate whole form; errors will show per-field with our custom messages
      this.$refs.ticketForm.validate((valid) => {
        if (valid) {
        //   this.$message.success("Form submitted successfully!");
          console.log("Submitted data:", this.formData);
          this.$emit('submit', this.formData)
        } else {
          // find first error field and show message (optional)
          // Element already displays per-field errors; this is just an extra toast
          const firstError = Object.values(this.$refs.ticketForm.fields || [])
            .find(f => f.validateMessage);
          if (firstError && firstError.validateMessage) {
            // this.$message.error(firstError.validateMessage);
          } else {
            // this.$message.error("Please complete all required fields.");
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.el-form {
  max-width: 600px;
}
</style>
